import cx from "classnames";
import { CardProps, defaultProps } from "./Card.type";
import styles from "./Card.module.scss"
import { Spinner } from "../Spinner";

export const Card = (props: CardProps) => {
	const { children, classnames, loading, withScrollBar, ...attributes } = { ...defaultProps, ...props };

	if (loading) {
		return (
			<div {...attributes} className={cx(styles.Card, classnames)}>
				<Spinner className={styles.CardSpinner} size="large" />
			</div>
		)
	}

	return (
		<div
			{...attributes}
			className={cx(
				styles.Card,
				classnames,
				withScrollBar && styles.WithScrollBar
			)}
		>
			{children}
		</div>
	)
};
